'use client';

import { useEffect } from 'react';
import { DealerPriceAvailabilityResponse } from 'services/dealerPriceAvailability/types';
import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { areEqualArrays } from './utils';
import { usePriceAndFitmentContext } from 'app/[lang]/[esite]/contexts/price-and-fitment-context/price-and-fitment-context';
import { PriceAvailabilityResponseHeadless } from 'services/priceAvailability/types';

interface AnalyticsClientProps {
  priceAndAvailabilityResponse?:
    | DealerPriceAvailabilityResponse
    | PriceAvailabilityResponseHeadless;
  fitmentData?: ProductFitmentResponse;
  priceAndAvailabilityKey?: string;
  index?: number;
  shouldResetFitment?: boolean;
}

const PriceAndFitmentContextEntry = ({
  priceAndAvailabilityResponse,
  fitmentData,
  priceAndAvailabilityKey,
  index,
  shouldResetFitment
}: AnalyticsClientProps) => {
  const {
    priceAndAvailability,
    setPriceAndAvailability,
    fitmentResponse,
    setFitmentResponse,
    setUrlParams,
    urlParams
  } = usePriceAndFitmentContext();

  useEffect(() => {
    const fitmentDataArray = Object.keys(fitmentData ?? {});
    const fitmentContextArray = Object.keys(fitmentResponse ?? {});
    if (
      !isEmpty(fitmentData) &&
      index === 0 &&
      !areEqualArrays(fitmentDataArray, fitmentContextArray)
    ) {
      setFitmentResponse(fitmentData);
    }
  }, [
    index,
    fitmentResponse,
    fitmentData,
    setFitmentResponse,
    priceAndAvailabilityKey
  ]);

  useEffect(() => {
    if (
      !isEmpty(priceAndAvailabilityResponse) &&
      index === 0 &&
      urlParams !== priceAndAvailabilityKey
    ) {
      setUrlParams(priceAndAvailabilityKey);
      setPriceAndAvailability(priceAndAvailabilityResponse);
    }
  }, [
    index,
    priceAndAvailability,
    priceAndAvailabilityResponse,
    setPriceAndAvailability,
    priceAndAvailabilityKey,
    urlParams,
    setUrlParams
  ]);

  useEffect(() => {
    if (!isEmpty(fitmentResponse) && shouldResetFitment) {
      setFitmentResponse(null);
    }
  }, [shouldResetFitment, fitmentResponse, setFitmentResponse]);

  return null;
};

export default PriceAndFitmentContextEntry;
